import { render, staticRenderFns } from "./TicketingForm.vue?vue&type=template&id=cd97897c&scoped=true&"
import script from "./TicketingForm.vue?vue&type=script&lang=js&"
export * from "./TicketingForm.vue?vue&type=script&lang=js&"
import style0 from "./TicketingForm.vue?vue&type=style&index=0&id=cd97897c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd97897c",
  null
  
)

export default component.exports